import { render, staticRenderFns } from "./BuyTariffPacketItem.vue?vue&type=template&id=73b11fcb&scoped=true"
import script from "./BuyTariffPacketItem.vue?vue&type=script&lang=js"
export * from "./BuyTariffPacketItem.vue?vue&type=script&lang=js"
import style0 from "./BuyTariffPacketItem.vue?vue&type=style&index=0&id=73b11fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b11fcb",
  null
  
)

export default component.exports